




























    /* eslint-disable @typescript-eslint/camelcase */  
    import {   noticiaService } from '@/servicegerente'; 
	import $ from "jquery"   
    import { Component, Vue } from 'vue-property-decorator';
    import { namespace } from 'vuex-class';
    const usuario = namespace('usuario')
    const gerente = namespace('gerente') 


    @Component({
        components: { },
    })
    export default class IndexGuia extends Vue { 


        
        @gerente.State
		public modulo! 


        private  reloadDatatable = false ; 
       

        private config = { 
            responsive: {
                details: { 
                    display: $.fn.dataTable.Responsive.display.modal( {
                        header: function ( row: any ) {  
                            return 'Descrição' ;
                        }, 
                    } ),

                    renderer: function ( api: any, rowIdx: any, columns: any ) {
                        const data = $.map( columns, function ( col, i ) {
                            return col.hidden ?
                                '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+ '<td class="escuro-modal-texto">'+col.data+'</td>'+
                                '</tr>' + '<tr><td><br><hr></td></tr>'+ '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+ '<td>'+col.data+'</td>'+ '</tr>' : '';
                        } ).join('');
                            
                        return data ?
                            $('<table/>').append( data ) :
                            false;
                    } 
                }
            }, 
            order: [  [2, "asc"] ],
            ajax: {
                url: noticiaService.getUrl() + '/datatable',
            },
            columns: [
                { "class": "details-control text-success", "orderable": false, "data": null, "defaultContent": ""  },  
                { data: 'id', name: 'id',  class: 'text-center' },
                { data: 'nome',  name: 'nome'  }, 
                { data: 'resumo',  name: 'resumo',  class: 'none' },   
                { data: 'action',  name: 'action', orderable: false, searchable: false,  class: 'text-center' }, 
            ],

        };
 


        created() { 
            if(!this.modulo){
				this.$router.push('/v2/administracao'); 
			} 
            this.config.ajax.url =  noticiaService.getUrl() + '/modulo/' + this.modulo.id + '/datatable'
        }



        public tableatualizada( ) {  
             
             
            $('[btn-editar]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id'); 
                window.open('#/v2/administracao/noticia/edit/' + id);  
            });
            $('[btn-visualizar]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id'); 
                this.$router.push('/v2/administracao/noticia/show/' + id);
            }); 

            $('[btn-desativar]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id');  
                window.alertConfimacao('Confirma a Desativação ','' , 
                     () => {  
                        window.alertProcessando(); 
                        noticiaService.desativar(  id )
                        .then(response => {
                            window.alertProcessandoHide();  
                            this.reloadDatatable = !this.reloadDatatable; 
                            window.toastSucesso('desativação realizada com sucesso!!' ); 
                        })
                        .catch(error => { 
                            window.alertProcessandoHide();
                            window.toastErro('Não foi possivel desativar ' , error.data.message); 
                        });  
                    }
                ); 
            });
    
            $('[btn-ativar]').click(  (btn) => {   
                const id =   $(btn.currentTarget).data('id'); 
                window.alertConfimacao('Confirma a Ativação ','' , 
                     () => {  
                        window.alertProcessando(); 
                        noticiaService.ativar(  id )
                        .then(response => {
                            window.alertProcessandoHide();  
                            this.reloadDatatable = !this.reloadDatatable; 
                            window.toastSucesso('ativação realizada com sucesso!!' ); 
                        })
                        .catch(error => { 
                            window.alertProcessandoHide();
                            window.toastErro('Não foi possivel ativar ' , error.data.message); 
                        });  
                    }
                ); 
            });
    
            $('[btn-excluir]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id');  
                window.alertConfimacao('Confirma a Exclusão ','' , 
                     () => {  
                        window.alertProcessando(); 
                        noticiaService.excluir(  id )
                        .then(response => {
                            window.alertProcessandoHide();  
                            this.reloadDatatable = !this.reloadDatatable; 
                            window.toastSucesso('Exclusao realizada com sucesso!!' ); 
                        })
                        .catch(error => { 
                            window.alertProcessandoHide();
                            window.toastErro('Não foi possivel Excluir ' , error.data.message); 
                        });  
                    }
                ); 
            });

        }
    }
 
